
import ValidationHelper from "@/utils/validation.util";
import useTranslation from "../../../hooks/useTranslate.hook";
import Button, { ButtonColor } from "../../buttons/basic";
import Loader from "../../loader";
import Modal from "../../modal";

type ConfirmModalType = {
    onConfirm: Function;
    onCancel: Function;
    confirmText?: string;
    confirmIcon?: any;
    cancelText?: string;
    cancelIcon?: any;
    message?: string | string[];
    title?: string;
    subtitle?: string;
    isOpen?: boolean;
    style?: "error" | "success";
    isLoading?: boolean;
    children?: any;
    showClose?: boolean;
    icon?: any;
    iconSize?: string;
    isConfirmDisabled?: boolean;
    isActionPending?: boolean;
    leftFooterText?: string;
    customButtonClasses?: any;
    headerStyle?: string;
    showConfirm?: boolean;
    size?: "small" | "smallish" | "medium" | "large" | "extra-large" | "huge" | "massive" | undefined;
};


const dialogStyleClasses: Record<string, string> = {
    error: 'c-confirm-modal__error',
    info: 'c-confirm-modal__info',
    success: 'c-confirm-modal__success'
}

const ModalConfirm = ({
                          confirmText,
                          confirmIcon,
                          cancelText,
                          cancelIcon,
                          isOpen = false,
                          message,
                          style = "success",
                          onConfirm,
                          onCancel,
                          isLoading,
                          children,
                          title = "",
                          showClose = true,
                          isConfirmDisabled = false,
                          icon,
                          iconSize,
                          isActionPending = false,
                          leftFooterText,
                          customButtonClasses,
                          headerStyle,
                          showConfirm = true,
                          size
                      }: ConfirmModalType) => {
    const { t } = useTranslation();
    const handleClose = () => {
        onCancel();
    }
    const classConfig = (headerStyle && dialogStyleClasses[headerStyle]) ?? '';
    return (
        <Modal isOpen={isOpen} closeModal={() => handleClose()} size={size} title={title} classConfig={classConfig}>
            {isLoading && (<div className="c-confirm-modal__loading"><Loader width={80} /></div>)}
            <div className="u-grid u-grid--gap-24 c-confirm-modal__message" style={{gridTemplateColumns: `${!!icon ? (!!iconSize ? iconSize + " " : "4rem ") : ""}1fr`}}>
                {!!icon ? icon : <></>}
                {message &&
                    (Array.isArray(message) ?
                        <div>{message.map((m, i) => <div key={i}>{m}</div>)}</div> :
                        <p>{message}</p>
                    )
                }
                {children}
            </div>

            <div className="c-confirm-modal__buttons-wrap">
                {leftFooterText && <span>{leftFooterText}</span>}
                {showClose && (
                    <Button 
                        onClick={() => handleClose()} 
                        text={cancelText ? cancelText : t("cancel")} 
                        variant="outlined" 
                        color={style} 
                        customClasses="c-btn-blackprimary"
                        icon={cancelIcon}
                    />
                )}
                {showConfirm && <Button
                    disabled={isConfirmDisabled} 
                    isLoading={isActionPending} 
                    onClick={() => onConfirm()} 
                    text={confirmText ? confirmText : t("yes")} 
                    variant="contained" 
                    color={style}
                    customClasses={customButtonClasses}
                    icon={confirmIcon}
                />}
            </div>
        </Modal>
    )
}

export default ModalConfirm;
